import { doc, deleteDoc } from "firebase/firestore";
import { db } from "../../../firebase";

const deleteCampaign = async (campaignId) => {
  try {
    const deleteCampaignCollection = await doc(db, "campaign", campaignId);
    await deleteDoc(deleteCampaignCollection);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default deleteCampaign;
